module.exports = __webpack_public_path__ + "static/media/Trash-Car-For-Cash-Brisbane-a1autorecycling.e514c6fa.jpg";